import { render, staticRenderFns } from "./TabIndicator.vue?vue&type=template&id=8a9d273e&scoped=true"
import script from "./TabIndicator.vue?vue&type=script&lang=js"
export * from "./TabIndicator.vue?vue&type=script&lang=js"
import style0 from "./TabIndicator.vue?vue&type=style&index=0&id=8a9d273e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9d273e",
  null
  
)

export default component.exports